import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { message } from 'antd';
import DoughnutChart from 'components/Charts/DoughnutChart';
import { DashboardChartProps } from './types';
import coursesApiClient from 'utils/coursesApiClient';

const ObjectiveProgressChart: React.FC<DashboardChartProps> = ({ customerUuid }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({
    data: {},
    inner: {},
  });

  const intl = useIntl();

  useEffect(() => {
    const loadData = async () => {
      try {
        setIsLoading(true);

        const url = `/api/v1/courses/statistic/dashboard/campaigns/customer/${customerUuid}/overall-learning-progress`;
        const response = await coursesApiClient.request(url);
        const responseData = response.statistic;

        const data = {
          data: [
            responseData.notStarted,
            responseData.inProgress,
            responseData.completed,
          ],
          total: responseData.total,
        };

        const parsedData = {
          data: {
            labels: [
              intl.formatMessage({ id: 'general.not_started' }),
              intl.formatMessage({ id: 'general.in_progress' }),
              intl.formatMessage({ id: 'general.completed' }),
            ],
            datasets: [{
              data: data.data,
              backgroundColor: [
                'rgb(244, 98, 100)',
                'rgb(126, 162, 223)',
                'rgb(33, 208, 160)',
              ],
              hoverBackgroundColor: [
                'rgb(224 ,68, 80)',
                'rgb(106, 142, 203)',
                'rgb(13, 188, 140)',
              ],
            }],
          },
          inner: {
            text: `${intl.formatMessage({ id: 'campaign.total_learning_activities_enrolled' })}*`,
            number: data.total,
            small: true,
          },
        };

        setData(parsedData);
      } catch (error) {
        console.error(error);
        message.error(intl.formatMessage({ id: 'error.data_load' }));
      } finally {
        setIsLoading(false);
      }
    }

    loadData();
  }, [intl, customerUuid]);

  return (
    <DoughnutChart
      data={data.data}
      title={intl.formatMessage({ id: 'campaign.overall_learning_objective_progress' })}
      inner={data.inner}
      footer={`*${intl.formatMessage({ id: 'campaign.all_learning_campaigns' })}`}
      loading={isLoading}
    />
  );
}

export default ObjectiveProgressChart;